<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <label > Department </label>
            <div v-for="d in department" :key="d.id">
              <b-form-checkbox type="checkbox"  :value="d.id" v-model="form.department_id">
            {{ d.name }}
              </b-form-checkbox>
            </div>
          </CCol> 
          </CRow>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="assign_department(form.uuid, form.department_id)"  variant="outline" color="info">Update</CButton>
    
      </template>
    </CModal>
  </form>

</template>

<script>
import axios from 'axios'
import EventBus from '@/eventBus';

import department from '@/services/department'
import member from '@/services/member'

export default {
name: 'departmentmodal',
components: { },
  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        department_id:[],
        uuid:''
      },
      department_id:[],
    }
  },
  created () {
    
    var self = this;
    EventBus.$on('OPEN_MODAL_DEPARTMENT', (params) => {
      if(params.data){
        self.form.uuid = params.data
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.department_id = params.departmentIDSelected;

        console.log("params", params)
        // department.getDepartmentbyID(params.data)
        // .then(res => {
        //   self.show = true;
        //   self.title = params.title;
        //   self.mode = params.mode;
        //   //self.form.id = res.data.id;
        //   //self.form.uuid = res.data.uuid;
        //   //self.form.name = res.data.name;
        // }).catch ((err) => {
        // var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        // EventBus.$emit('OPEN_MODAL_ALERT', params)
        // })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.uuid = "";
        self.form.name = "";
      }
    });
    //this.form.uuid = this.$route.query.Pud
    
  },
   mounted (){
     this.loadData()
   },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    
    loadData() {
      member.getMemberbyID(this.$route.query.Pud)
      .then(res => {
          let getData = res
           for (var i = 0; i < getData.data.department.length; i++) {

            this.form.department_id.push(getData.data.department_id[i].id); }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
      department.getDepartment()
      .then(res => {
        console.log('load data masuk')
         console.log(res)
          let getData = res
          this.department = getData.data
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

      
    },
    
    assign_department(id,department_id){
      this.show = false;
      if(confirm("Do you really want to change your department?")){
          var param = {
            department_id: department_id,
          }
          member.assign_department(id, param)
          .then(res => {
             EventBus.$emit('PAGE_UPDATE', true)
            //this.load()
            console.log(id, param)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
    },
  }
}
</script>

<style>

</style>